import { render, staticRenderFns } from "./GridCarnes.vue?vue&type=template&id=6df043b8&scoped=true&"
import script from "./GridCarnes.vue?vue&type=script&lang=js&"
export * from "./GridCarnes.vue?vue&type=script&lang=js&"
import style0 from "./GridCarnes.vue?vue&type=style&index=0&id=6df043b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df043b8",
  null
  
)

export default component.exports